'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowRight, CheckCircleSolid, Duration, InfoCircle, MapPinSolid, WarningTriangle, Xmark } from '@byway/icons';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { CardShell } from 'ui';
import styles from './MessagePanel.module.css';
import type { MessagePanelProps } from './MessagePanel.types';
const MessagePanel = t0 => {
  const $ = _c(29);
  const {
    message,
    status: t1,
    onClose,
    dismissable: t2
  } = t0;
  const status = t1 === undefined ? "info" : t1;
  const dismissable = t2 === undefined ? false : t2;
  const t = useTranslations("aria");
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      alert: "bg-status-alert print:bg-transparent",
      disruption: "bg-status-error text-white print:bg-transparent print:text-black",
      error: "bg-primary-100 print:bg-transparent",
      info: "bg-status-info print:bg-transparent",
      success: "bg-white print:bg-transparent",
      timetabling: "bg-status-alert print:bg-transparent",
      directions: "bg-status-info print:bg-transparent"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const statusFill = t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      alert: "border-yellow-800",
      disruption: "border-primary-800",
      error: "border-primary-800",
      info: "border-blue-800",
      success: "border-black",
      timetabling: "border-yellow-800",
      directions: "border-neutral-300"
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const statusBorder = t4;
  const [isOpen, setIsOpen] = useState(true);
  let t5;
  if ($[2] !== status || $[3] !== t) {
    t5 = () => {
      switch (status) {
        case "alert":
          {
            return <WarningTriangle size="large" ariaLabel={t("important")} />;
          }
        case "timetabling":
          {
            return <Duration size="large" ariaLabel={t("timings")} strokeWidth={2} />;
          }
        case "error":
          {
            return <WarningTriangle ariaLabel={t("error")} size="large" />;
          }
        case "success":
          {
            return <CheckCircleSolid ariaLabel={t("success")} size="large" color="var(--by-color-icon-success)" />;
          }
        case "directions":
          {
            return <MapPinSolid size="large" ariaLabel={t("directions")} />;
          }
        default:
          {
            return <InfoCircle size="large" ariaLabel={t("information")} />;
          }
      }
    };
    $[2] = status;
    $[3] = t;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const statusIcon = t5;
  let t6;
  if ($[5] !== status) {
    t6 = () => {
      switch (status) {
        case "directions":
          {
            return <span className="flex items-center justify-center w-5 h-5 text-blue-800"><ArrowRight size="large" decorative={true} /></span>;
          }
        default:
          {
            return null;
          }
      }
    };
    $[5] = status;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const rightSideIcon = t6;
  if (!isOpen) {
    return null;
  }
  const t7 = statusFill[status];
  const t8 = statusBorder[status];
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = clsx("flex items-center justify-between space-x-2 print:break-inside-avoid", styles.container);
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== statusIcon) {
    t10 = <span>{statusIcon()}</span>;
    $[8] = statusIcon;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== message) {
    t11 = <span>{message}</span>;
    $[10] = message;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t10 || $[13] !== t11) {
    t12 = <div className="flex space-x-2 items-top">{t10}{t11}</div>;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== rightSideIcon) {
    t13 = rightSideIcon();
    $[15] = rightSideIcon;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== dismissable || $[18] !== onClose || $[19] !== t) {
    t14 = dismissable && <button type="button" onClick={() => {
      onClose?.();
      setIsOpen(false);
    }} className="flex items-center justify-center w-5 h-5"><Xmark ariaLabel={t("close")} size="large" /></button>;
    $[17] = dismissable;
    $[18] = onClose;
    $[19] = t;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t12 || $[22] !== t13 || $[23] !== t14) {
    t15 = <div className={t9}>{t12}{t13}{t14}</div>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== t15 || $[26] !== t7 || $[27] !== t8) {
    t16 = <CardShell fill={t7} hasBorder={true} border={t8}>{t15}</CardShell>;
    $[25] = t15;
    $[26] = t7;
    $[27] = t8;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  return t16;
};
export { MessagePanel };